import {cacheRésultats} from "./dom.js";
import {OptionRecherche} from "./OptionRecherche.js";
import {Pagination} from "./Pagination.js";
import {Événements, ÉvénementsGTM} from "./constantes.js";
import {Recherche} from "./Recherche.js";
import {Cibles} from "./Cibles.js";
import {GestionnaireURL} from "./GestionnaireURL.js";

export class MoteurDeRecherche {

    static pagination = new Pagination();

    static actualiseRecherche(événement) {
        const recherche = événement.detail.recherche;
        if (!recherche || !recherche.critères || recherche.critères.size === 0) {
            cacheRésultats();
            return;
        }

        return MoteurDeRecherche.exécute(recherche);
    }

    static async exécute(recherche, pagination, tri) {

        if (pagination) {
            // Pour conserver en cas d'actualisation des résultats (un peu bâtard...)
            MoteurDeRecherche.pagination = pagination;
        }

        let rechercheClonée = recherche.clone();

        // On exécute pas la recherche s'il n'y a pas au moins un critère!
        if (rechercheClonée.critères.size === 0) return;

        const usitoMotsDiv = [...document.getElementsByClassName("usito-mots")][0];
        const ancienCurseur = usitoMotsDiv.style.cursor;

        usitoMotsDiv.style.cursor = "progress";

        const requêteAPI = MoteurDeRecherche.getRequêteFormatAPI(rechercheClonée);
        const requêteAPIJson = JSON.stringify(requêteAPI);

        try {

            this.journaliseExécution(rechercheClonée);

            const retourApi = await MoteurDeRecherche.getMots(requêteAPIJson);

            const données = retourApi.données;

            MoteurDeRecherche.pagination.nbRésultats = données.résultat.items.length;
            MoteurDeRecherche.pagination.nbTotalRésultats = données.résultat.résultatsInfo.nbTotalRésultats;
            MoteurDeRecherche.pagination.nbTotalPages = données.résultat.résultatsInfo.nbPages;
            // On ne récupère pas le retour de l'API afin de conserver le choix de l'utilisateur.
            // Pour l'instant, nbItemsParPage est toujours égale à nbTotalItems puisque le BE ne retourne qu'une seule page
            // MoteurDeRecherche.pagination.taillePage = données.résultat.résultatsInfo.nbItemsParPage;
            MoteurDeRecherche.pagination.pageCourante = données.résultat.résultatsInfo.pageRéf.page;

            // On passe la rechercheClonée pour permettre notamment une vérification empêchant
            // éventuellement que des résultats "périmés" soient affichés.
            MoteurDeRecherche.actualiseRésultats(données, rechercheClonée);

            usitoMotsDiv.style.cursor = ancienCurseur;

        } catch (error) {
            usitoMotsDiv.style.cursor = ancienCurseur;
            alert(error.message);
            console.error(error);
        }

    }

    static journaliseExécution(recherche) {

        const libelléMots = [recherche.critères.size, ...recherche.critères.keys()].join("|");
        envoyerÉvénementGTM(ÉvénementsGTM.RECHERCHE.code, ÉvénementsGTM.RECHERCHE.actions.MOTS, libelléMots);

        if (recherche.hasCible(Cibles.LISTE_MEQ)) {
            const libelléListeMEQ = [...recherche.critères.keys()]
                .filter(cible => cible.startsWith(Cibles.LISTE_MEQ.code))
                .join("|");
            envoyerÉvénementGTM(ÉvénementsGTM.RECHERCHE.code, ÉvénementsGTM.RECHERCHE.actions.MOTS_LISTEMEQ, libelléListeMEQ);
        }
    }

    static actualiseRésultats(données, recherche) {

        if (!données) {
            cacheRésultats();
            return;
        }

        recherche.hash = Recherche.getHash(recherche);
        recherche.ts = Date.now();
        recherche.nbTotalItems = données.résultat.résultatsInfo.nbTotalRésultats;

        // générer événement
        const nouvellesDonnéesÉvénement = new CustomEvent(Événements.NOUVELLES_DONNÉES, {
            detail: {
                données: données,
                recherche: recherche
            }
        })
        document.dispatchEvent(nouvellesDonnéesÉvénement);

    }


    static getRequêteFormatAPI(recherche) {
        let rechercheAvecValeursDécomposées = [];

        [...recherche.critères.values()].forEach(critère => {
            let valeursDécomposées = [];
            critère.valeurs.forEach(v => {
                valeursDécomposées.push(...v.split(","))
            })

            rechercheAvecValeursDécomposées.push({
                cible: critère.cible,
                comparateur: critère.comparateur,
                valeurs: valeursDécomposées
            });
        })

        let vc = recherche.options.get(OptionRecherche.FILTRE_INCLURE_VERBES_CONJUGUÉS.code);
        let ls = recherche.options.get(OptionRecherche.FILTRE_LEMMES_SEULEMENT.code);

        return {
            critères: rechercheAvecValeursDécomposées,
            options: [
                vc,
                ls
            ]
        }
    }


    static async getMots(requêteAPIJson) {
        //console.log("Exécute recherche", requêteAPIJson);

        const url = new URL("/v2/mots", window.location.origin);

        url.searchParams.set(GestionnaireURL.urlParams.RECHERCHE_COMPRESSÉE, requêteAPIJson);
        // Le jour où l'on souhaitera paginer véritablement
        // url.searchParams.set("page", String(MoteurDeRecherche.pagination.pageCourante));
        // url.searchParams.set("nbItemsParPage", String(MoteurDeRecherche.pagination.taillePage));
        url.searchParams.set("page", "0");
        url.searchParams.set("nbItemsParPage", String(Pagination.maxItemsParPage));

        const request = new Request(url);

        const réponse = await fetch(request);

        if (!réponse.ok) {
            if (réponse.status === 400) {
                throw new Error(`Recherche non valide`);
            } else {
                throw new Error(`Erreur lors de l'exécution de la recherche (${réponse.status})`);
            }
        }

        const retourApi = await réponse.json();

        if (retourApi.codeHTTP !== 'OK') {
            console.error(retourApi);
            throw new Error(`Erreur lors de l'exécution de la recherche (${réponse.status})`);
        }

        return retourApi;
    }

}


document.addEventListener(Événements.NOUVEAU_CRITÈRE, MoteurDeRecherche.actualiseRecherche);
document.addEventListener(Événements.SUPPRESSION_CRITÈRE, MoteurDeRecherche.actualiseRecherche);
document.addEventListener(Événements.NOUVELLE_RECHERCHE, MoteurDeRecherche.actualiseRecherche);
